import nAry from "./nAry";

// (* -> b) -> (() -> b)
const nullary = nAry(0);

export default nullary;
